<template>
  <div id="radarPane" :style="styleObject">
    <color-bar :colors="colors" />
    <slider 
      :max="max" 
      :min="min"
      :step="step"
      :marks="marks"
      :list="radarList"
      @slider-step="onSliderChange"
      @play-step="onSliderChange"
      @play-stopped="onSliderEnd"
    />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import api from '../modules/api'
import L from '../modules/leaflet'
import Slider from '../components/control/Slider.vue'
import ColorBar from '../components/control/ColorBar.vue'
import { COLORS_DEF } from '../modules/colors'

const PANE_ID = "radar"
const PANE_LAYER = "radar-layer"
const RADAR_BOUND = [[12.7700338517, 63.8148899733],[56.3833398551, 143.536486117]]

function createImageLayer(url) {
  const imageLayer = L.imageOverlay(url, RADAR_BOUND, {opacity: 1, zIndex: 0});
  const content = [
    `<div id='precipPan'>`,
      `<div style="width:100%;height:200px" id="precipChart"></div>`,
    `</div>`
  ].join('')
  imageLayer.bindPopup(content, {minWidth: 500})

  imageLayer.on("popupopen", function(ev) {
    console.log(ev.popup)
    //console.log(ctx.precipData)
    //RadarPane.paintChart("precipChart", ctx)
  })
  return imageLayer
}

export default {
  setup() {
    const store = useStore()
    const currentPaneId = computed(() => store.state.currentPaneId)
    const map = computed(() => store.state.map)
    return {
      currentPaneId,
      map
    }
  },

  components: {
    Slider,
    ColorBar
  },

  data() {
    return {
      radarList: [],
      imageLayer: null,
      colors: COLORS_DEF.RADAR,
      min: 0,
      max: 20,
      step: 1,
      marks: {
        0: "00:00",
        10: "01:00",
        20: "02:00"
      }
    }
  },

  computed: {
    styleObject() {
      return this.currentPaneId != PANE_ID ? { "display": "none" } : {}
    }
  },

  mounted() {
    this.init()
  },

  beforeUnmount() {
    this.clear()
  },

  methods: {
    onSliderChange(value) {
      this.setImage(value)
    },

    onSliderEnd() {
      this.setImage(this.$data.min)
    },

    setImage(index) {
      if(this.radarList.length > 0 && this.radarList[index]) {
        if (this.imageLayer) {
          this.imageLayer.setUrl(this.radarList[index].url)
        }
      }
    },

    getMap() {
      return this.$store.state.map
    },

    init() {
      console.log("    > loading pane .....", PANE_ID)
      api.fetchRadar().then((radars) => {

        this.radarList = radars
        const length = radars.length

        //preload
        this.radarList.forEach((r) => {
          const preLoad = new Image()
          preLoad.src = r.url
        })

        // set parameters for slider
        this.$data.max = length - 1
        const marks = {}
        marks[0] = {label: radars[0].display.split(' ')[1]}
        marks[(length-1)/2] = {label: radars[(length-1)/2].display.split(' ')[1]}
        marks[length - 1] = {label: radars[length - 1].display.split(' ')[1]}
        this.$data.marks = marks

        this.imageLayer = createImageLayer(radars[0].url)
        if (this.currentPaneId == PANE_ID) {
          this.getMap().addLayer(PANE_LAYER, L.layerGroup([this.imageLayer]))
        }
      })
    },

    clear() {
      console.log("    > closing pane .....", PANE_ID)
      const map = this.$store.state.map
      map.removeLayer(PANE_LAYER)
    }
  }
}

</script>

<style>
#radarPane {
  z-index: 31; 
  width: 650px; 
  font-size: 10px;
  background-color: #fff!important;
  border-radius: .25rem!important;
  position: absolute!important;
  left: 50%!important;
  transform: translateX(-50%)!important;
  box-shadow: 0 1rem 3rem rgba(0,0,0,.175)!important;
  bottom:0;
  margin-bottom: .5rem!important;
  font-size: 10px;
}

@media (max-width: 780px) {
  #radarPane { width: 350px; }
}

</style>